import React, { ReactNode } from 'react'
import styled from 'styled-components'
import getEnvVars from "../../environment/environment";

const DebugWrapper = styled.div`
    margin-top: 25px;
    padding: 5px;
    border: 1px solid grey;
    overflow: hidden;
    overflow-x: scroll;
    max-height: 90px;
    overflow-y: scroll;
`

interface DebugContainerProps {
    children?: ReactNode
}

export const DebugContainer: React.FC = (props: DebugContainerProps) => {
    const { children } = props

    console.log(getEnvVars.environment)

    if (getEnvVars.environment == "development") {
        return <DebugWrapper className="color-white">{children}</DebugWrapper>
    }
    return null

}

export default DebugContainer
